module.exports = __webpack_public_path__ + "img/play.14f0ae4d.svg";